export default __webpack_public_path__ + "static/media/code-fork-solid.3780729d.svg";